export const LIST_CALENDAR_DAY_GAP = 0.125;
export const LIST_CALENDAR_MIN_DAY_WIDTH = 4;

export const LIST_CALENDAR_DEFAULT_BG_COLOR = 'palette.pause.background.light';
export const LIST_CALENDAR_BORDER_COLOR = 'palette.pause.background.dark';

export const LIST_CALENDAR_NON_WORKING_DAY_COLOR = 'palette.pause.background.medium';
